const productQtyLessBtn = document.querySelector('.js-control-qty.qty-control-btn--less');
const productQtyMoreBtn = document.querySelector('.js-control-qty.qty-control-btn--more');
const productQtyField = document.querySelector('.quantity input.qty');

// Control quantity 
if (productQtyLessBtn) {
    // less qty 
    productQtyLessBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const value = parseInt(productQtyField.value, 10);
        const step = parseInt(productQtyField.getAttribute('step'), 10);
        const min = parseInt(productQtyField.getAttribute('min'), 10);

        if (value > min && (value - step) >= min) {
            productQtyField.value = (value - step);
        } else {
            productQtyField.value = min;
        }
    });
}

if (productQtyMoreBtn) {
    // more qty 
    productQtyMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const value = parseInt(productQtyField.value, 10);
        const step = parseInt(productQtyField.getAttribute('step'), 10);
        let max = productQtyField.getAttribute('max');

        max = (max != '') ? parseInt(max, 10) : '';

        if (max == '' || max != "" && value < max && (value + step) <= max) {
            productQtyField.value = (value + step);
        } else {
            productQtyField.value = max;
            alert('Vous ne pouvez pas ajouter plus de ' + max + ' unité(s)');
        }
    });
}